'use client'
import goToSearchV2 from '@/navigation/CSR/goToSearchV2/goToSearch'
import { PAGINATION_SIZE_SEARCH } from '@/utils/constants'
import { Col, Pagination, Row } from 'antd'
import { useRouter } from 'next/navigation'
import { IParamsByUrl, PaginationModel } from '~types/search'

const PaginationRow = ({
  pagination,
  urlParams,
}: {
  pagination: PaginationModel
  urlParams: IParamsByUrl
}) => {
  const router = useRouter()
  if (pagination.pages === 1) return null

  const handleChange = async (page: number) => {
    await goToSearchV2({
      router,
      urlParams,
      action: 'changePage',
      page,
    })
  }

  return (
    <Row style={{ marginBottom: 16 }}>
      <Col span={24}>
        <Pagination
          simple
          current={pagination.page}
          total={pagination.total.value}
          pageSize={PAGINATION_SIZE_SEARCH}
          onChange={handleChange}
          showSizeChanger={false}
        />
      </Col>
    </Row>
  )
}

export default PaginationRow
